<template>
  <div>
    <TModalCritical
      v-model:visible="showMobileSearchForm"
     
      size="full"
      title=""
    >
      <template #default="{ dismiss }">
        <LazySearchFormMobile
          v-if="mobileSearchFormLoaded"
          :is-campgrounds="isCampgrounds"
          :has-rental-type="hasRentalType"
          @close="dismiss()"
        />
      </template>
    </TModalCritical>

    <div class="min-w-0">
      <button
        v-bind="$attrs"
        class="w-full flex items-center gap-x-2 bg-white border border-gray-200 pl-5 pr-3 py-2 rounded-full text-left cursor-pointer hover:bg-gray-100 hover:shadow-md transition-colors duration-200 ease-in-out"
        type="button"
       
        @click="openMobileSearch()"
      >
        <span class="truncate flex-1">
          <span class="font-medium text-base">{{ isCampgrounds ? collapsedCampgroundsLocationLabel : collapsedRvsLocationLabel }}</span>
          <span
            v-if="!isCampgrounds"
            class="block text-sm text-gray-500"
          >
            {{ collapsedDatesLabel }} &vert; {{ collapsedGuestsLabel }}<template v-if="hasRentalType"> &vert; {{ collapsedRentalTypeLabel }}</template>
          </span>
        </span>

        <span class="text-white bg-secondary rounded-full size-10 flex items-center justify-center">
          <TIcon
            :icon="['far', 'magnifying-glass']"
            size="lg"
          />
        </span>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  isCampgrounds?: boolean
  hasRentalType?: boolean
}>()

const { updateSearchFormLocation } = useSearchForm()
const {
  searchData,
  locationLabel,
  collapsedCampgroundsLocationLabel,
  collapsedRvsLocationLabel,
  collapsedDatesLabel,
  collapsedGuestsLabel,
  collapsedRentalTypeLabel,
} = useSearch()

const mobileSearchFormLoaded = ref(false)
const showMobileSearchForm = ref(false)

function openMobileSearch() {
  // The campgrounds form only edits the location, so it starts from the one currently applied.
  if (props.isCampgrounds && searchData.value.location?.placeId) {
    updateSearchFormLocation({
      placeId: searchData.value.location.placeId,
      text: locationLabel.value,
    })
  }

  mobileSearchFormLoaded.value = true
  showMobileSearchForm.value = true
}
</script>

<i18n src="~~/i18n/locales/common/search/form.json" lang="json" />
